import { z } from "zod";
import { fallback } from "@tanstack/zod-adapter";
import { Region, RelocationStatus } from "@/gql/graphql";
import {
  RelocationTableState,
  defaultRelocationTableState,
} from "@/app/Relocations/Utils/relocationTableState";

const optionalSearchParam = <T extends z.ZodType>(schema: T) =>
  fallback(schema.optional(), undefined).default(undefined);

export const relocationTableSearchParams = z.object({
  relocationStatus: optionalSearchParam(z.array(z.enum(RelocationStatus))),
  relocationSupplierId: optionalSearchParam(z.string()),
  regions: optionalSearchParam(z.array(z.enum(Region))),
  relocationDepartureCityIds: optionalSearchParam(z.array(z.string())),
  relocationDeliveryCityIds: optionalSearchParam(z.array(z.string())),
  relocationPage: optionalSearchParam(z.number().int().positive()),
  relocationSearch: optionalSearchParam(z.string()),
});

export type RelocationTableSearchParams = z.infer<
  typeof relocationTableSearchParams
>;

export function parseRelocationTableSearch(rawSearch: unknown) {
  return relocationTableSearchParams.parse(rawSearch);
}

export const relocationTableSearchKeys = Object.keys(
  relocationTableSearchParams.shape,
) as (keyof RelocationTableSearchParams)[];

export function relocationTableStateFromSearch(
  search: RelocationTableSearchParams,
): RelocationTableState {
  return {
    statuses: search.relocationStatus ?? defaultRelocationTableState.statuses,
    supplierId: search.relocationSupplierId ?? null,
    regions: search.regions ?? [],
    departureCityIds: search.relocationDepartureCityIds ?? [],
    deliveryCityIds: search.relocationDeliveryCityIds ?? [],
    page: search.relocationPage ?? 1,
    search: search.relocationSearch ?? "",
  };
}

export function relocationTableSearchFromState(
  state: RelocationTableState,
): RelocationTableSearchParams {
  return {
    relocationStatus: state.statuses.length ? state.statuses : undefined,
    relocationSupplierId: state.supplierId ?? undefined,
    regions: state.regions.length ? state.regions : undefined,
    relocationDepartureCityIds: state.departureCityIds.length
      ? state.departureCityIds
      : undefined,
    relocationDeliveryCityIds: state.deliveryCityIds.length
      ? state.deliveryCityIds
      : undefined,
    relocationPage: state.page > 1 ? state.page : undefined,
    relocationSearch: state.search || undefined,
  };
}
